//-- React Standard
import {Button, Card, CardBody, CardFooter } from 'reactstrap';
import React, { Component } from "react";
import { connect } from 'react-redux';
//import compose from 'recompose/compose';
//-- Custom
import { apiConstants } from '../../_constants/api.constants';
import TopBar from "../Common/TopBar/TopBar";
import SideBar from "../Common/SideBar/SideBar";
import { settingsActions } from '../../_actions';
import { withStyles } from "@material-ui/core/styles";
import Footer from "../Common/Footer/Footer";

//-- CSS for Material
const styles = theme => ({
    error: {
        color: 'red',
    },
    loaderImg: {
        margin: '0 auto',
        display: 'block',
        width: '250px'
    },
    boldText: {
        fontWeight: 'bold'
    },
    pageImg: {
        width: '70px',
        height: '70px',
        position: 'relative',
        padding: '10px'
    },
    removeImg: {
        position: 'absolute',
        top: '-7px',
        right: '-7px',
        padding: '0px 7px 0px 7px',
        border: '1px solid #a09d9d',
        background: '#c1c1c1',
        borderRadius: '50%',
        fontWeight: 'bold',
        cursor: 'pointer',
        color: '#fff'
    },
    borderedImg: {
        position: 'relative',
        width: '70px',
        height: '70px',
        border: '1px #dad7d7 solid',
        borderRadius: '10px',
        float: 'left',
        marginBottom: '15px',
        marginRight: '15px'
    }
});

class Legal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            generalSettings: {
            refund_policy : ''
            },
            errors: {}
        }
    }

    //-- Will need to fetch generalSettings data
	componentDidMount() {
		const { dispatch } = this.props;
		let obj = {};
		dispatch(settingsActions.getGeneralSettings(apiConstants.GET_GENERAL_SETTING, obj));
    }
    
    /*
    * componentWillReceiveProps - Whenever Props change, it will call and store data
    * update the state values with new props values, this method will get called whenever any change happens to props values
    */
	componentWillReceiveProps(props) {
		if (props.getGeneralSettings) {
	 
				if (props.getGeneralSettings.getSettings !== undefined &&
					props.getGeneralSettings.getSettings.data !== undefined && 
					props.getGeneralSettings.getSettings.data._id !== undefined &&
					props.getGeneralSettings.getSettings.data.contactPerson !== null  ) {
					

					let oldGenData = props.getGeneralSettings.getSettings.data;					

					this.setState({
						generalSettings: {
							id : oldGenData._id,							
							shipping_policy : oldGenData.shippingPolicy,
							terms_service : oldGenData.termsService,
							refund_policy: oldGenData.refundPolicy
						}
					})
 
				}
		 
		}
	}

    closeButton = () => {
        this.props.history.push('/settings');
    }

    handleFields = (e) => {
        const { generalSettings } = this.state;
        this.setState({ generalSettings : { ...generalSettings, [e.target.name] : e.target.value } } );
    }
  
    
	//-- handle validation for page
	handleValidation() {
		const { siteConstants } = this.props.language;

		let fields = this.state.generalSettings;
		let errors = {};
		let formIsValid = true;		
		
		//Name
		if (fields["shipping_policy"] == undefined || fields["shipping_policy"] == '') {
			formIsValid = false;			
			errors["shipping_policy"] = siteConstants.ERR_CAN_NOT_BLANK;			
        }
        if ( fields["terms_service"] == undefined || fields["terms_service"] == '' ) {
			formIsValid = false;			
			errors["terms_service"] = siteConstants.ERR_CAN_NOT_BLANK;			
        }
        if ( fields["refund_policy"] == undefined || fields["refund_policy"] == '') {
			formIsValid = false;			
			errors["refund_policy"] = siteConstants.ERR_CAN_NOT_BLANK;			
		}

	 


		this.setState({ errors: errors });

		return formIsValid;
	}
    //-- update the general setting information
    handleSubmitEdit = (e) => {
        e.preventDefault();
        let obj = {}; 

        if (this.handleValidation()) {
            let { generalSettings } = this.state;
            this.props.dispatch(settingsActions.updateGeneralSettings(apiConstants.UPDATE_GENERAL_SETTINGS, generalSettings, apiConstants.GET_GENERAL_SETTING, obj ));
        }  
	}
    //-- Main function
    render() {
        const { siteConstants } = this.props.language;
        const { generalSettings } = this.state;

        return (
            <div id="wrapper">

                <SideBar />

                <div id="content-wrapper" className="d-flex flex-column">
                    {/* <!-- Main Content --> */}
                    <div id="content">

                        <TopBar />
                        <nav className="" aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href="/dashboard">{siteConstants.GEN_DASHBOARD}</a>
                                </li>
                                <li className="breadcrumb-item">
                                    <a href="/settings">{siteConstants.MENU_SETTINGS}</a>
                                </li>
                                <li className="active breadcrumb-item" aria-current="page">
                                    {siteConstants.GEN_LEGAL}
                                </li>
                                <li style={{ paddingLeft: "740px" }}>
                                    <a href="/settings" className="darkLink"><i class="fa fa-angle-left"></i> {siteConstants.BTN_BACK}
                                    </a>
                                </li>
                            </ol>
                        </nav>

                        {/* <!-- Begin Page Content --> */}
                        <div className="container-fluid">
                            <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-2">
                                <div>
                                    <div className="h3CustomeHeading">{siteConstants.GEN_LEGAL}</div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-4">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Card>
                                                <CardBody>
                                                    <strong>Legal pages</strong><br></br>
                                                    You can create your own legal pages, or create them from templates and customize them. The templates aren't legal advice and need to be customized for your store.

                                                    To keep your store secure, it's not possible to add audio, videos, or media widgets.

                                                    By using these templates you agree that you've read and agreed to the disclaimer.
                                                </CardBody>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-8">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <Card className="mb-2">
                                                <CardBody>
                                                    <Card className="mb-2">
                                                        <CardBody>
                                                            <strong>Refund policy</strong><br></br>
                                                            <label className="my-error">{this.state.errors["refund_policy"]}</label>
                                                            <textarea
                                                                className="form-control"
                                                                placeholder={siteConstants.GEN_DESCRIPTION}
                                                                name="refund_policy"
                                                                rows="12"                                                                
                                                                onChange={ (e)=>this.handleFields(e) }
                                                                value={generalSettings.refund_policy}
                                                            ></textarea>
                                                        </CardBody>
                                                    </Card>

                                                    <Card className="mb-2">
                                                        <CardBody>
                                                            <strong>Terms of service</strong><br></br>
                                                            <label className="my-error">{this.state.errors["terms_service"]}</label>
                                                            <textarea
                                                                className="form-control"
                                                                placeholder={siteConstants.GEN_DESCRIPTION}
                                                                name="terms_service"
                                                                rows="12"                                                                
                                                                onChange={ (e)=>this.handleFields(e) }
                                                                value={generalSettings.terms_service}
                                                            ></textarea>
                                                        </CardBody>
                                                    </Card>

                                                    <Card className="mb-2">
                                                        <CardBody>
                                                            <strong>Shipping policy</strong><br></br>
                                                            <label className="my-error">{this.state.errors["shipping_policy"]}</label>
                                                            <textarea
                                                                className="form-control"
                                                                placeholder={siteConstants.GEN_DESCRIPTION}
                                                                name="shipping_policy"
                                                                rows="12"
                                                                onChange={ (e)=>this.handleFields(e) }
                                                                value={generalSettings.shipping_policy}
                                                            ></textarea>
                                                        </CardBody>
                                                    </Card>
                                                </CardBody>

                                                <CardFooter>
                                                    <Button variant="contained" color="primary" onClick={(e) => this.handleSubmitEdit(e)}>{siteConstants.LABEL_SAVE}</Button>
                                                    &nbsp;<Button variant="contained" onClick={() => this.closeButton()}>{siteConstants.LABEL_CANCEL}</Button>
                                                </CardFooter>
                                            </Card>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- /.container-fluid --> */}

                    </div>
                    {/* <!-- End of Main Content --> */}

                    <Footer />
                </div>
            </div>
        );
    }
}


//-- Here we are adding Reducer names, so it can be get data from reducers using store
function mapStateToProps(state) {
    const { language, getGeneralSettings } = state;
    return {
        language,
        getGeneralSettings
    };
}
const connectedMembership = connect(mapStateToProps)(withStyles(styles)(Legal));
export { connectedMembership as Legal };